import axios from "axios";
import actions from "./actions";
import { generateGuid } from "./../../modules/guid";

const signIn = (username, password) => (dispatch, getState) => {
  dispatch(actions.signInStart());
  axios
    .post(`/api/sign-in?u=${generateGuid()}`, { username, password })
    .then(res => {
      dispatch(actions.signIn({ ...res.data }));
    })
    .catch(err => {
      dispatch(actions.signInError(err));
    });
};

const signOut = () => (dispatch, getState) => {
  axios.get(`/api/sign-out?u=${generateGuid()}`).then(res => {
    if (res.data.logouturl) {
      window.location = res.data.logouturl;
    } else {
     dispatch(actions.signOut(res.data));
    }
  });
};

const validateSession = () => (dispatch, getState) => {
  axios.get(`/api/session-status?u=${generateGuid()}`).then(res => {
    if (res.data.sso && res.data.sso.loginUrl) {
      try {
        if (/^\/summary-reports\/[0-9A-Fa-f]{8}[-][0-9A-Fa-f]{4}[-][0-9A-Fa-f]{4}[-][0-9A-Fa-f]{4}[-][0-9A-Fa-f]{12}/gm.test(window.location.pathname)) {
          localStorage.setItem('sso_referrer', window.location.pathname);
        }
      }
      catch (ex) {
        //don't set a referrer
      }
      if (window.location.pathname !== '/sign-out') {
        window.location = res.data.sso.loginUrl;
      } else {
        dispatch(actions.validateSession(res.data));
      }
    } else {
      dispatch(actions.validateSession(res.data));
    }
  });
};

const getAuthenticationServerUrl = () => (dispatch, getState) => {
  axios.get(`/api/authentication-server-url?u=${generateGuid()}`).then(res => {
    dispatch(actions.getAuthenticationServerUrl(res.data));
  });
};

export default {
  signIn,
  signOut,
  validateSession,
  getAuthenticationServerUrl,
};



// WEBPACK FOOTER //
// ./src/redux/user/operations.js